import { getLocalStorageItem, setLocalStorageItem } from 'Helpers/localStorage';
import { isEmpty } from 'Helpers/objects';

const COMPARISON_CARS_KEY = 'comparison-cars';

const updateSessionStorage = state => {
    const sessionItem = JSON.stringify(state);

    setLocalStorageItem(COMPARISON_CARS_KEY, sessionItem);
};

const reducer = (state = {}, action) => {
    const initialState = JSON.parse(getLocalStorageItem(COMPARISON_CARS_KEY)) || {};

    switch (action.type) {
        case 'ADD-CAR-TO-COMPARE':
        {
            const { itemId, ...data } = action.data;

            const stateObj = {
                ...state,
                [itemId]: {
                    ...data
                }
            };

            updateSessionStorage(stateObj);
            return stateObj;
        }

        case 'REMOVE-CAR-FROM-COMPARE':
        {
            const { itemId } = action.data;
            const stateObj = { ...state };

            delete stateObj[itemId];

            updateSessionStorage(stateObj);
            return stateObj;
        }

        case 'REMOVE-ALL-CARS-FROM-COMPARE':
        {
            const stateObj = {};

            updateSessionStorage(stateObj);
            return stateObj;
        }

        default:
            return isEmpty(state) ? initialState : state;
    }
};

export default reducer;
